/**
 * Values of the login page's ?error= query param. The first two are fixed by
 * Auth.js (https://errors.authjs.dev); the rest are emitted by the gates in
 * the [...nextauth] route handler ahead of Auth.js.
 */
export enum AuthErrorCode {
    /** Any failure Auth.js does not consider client-safe: adapter throws, a missing PKCE cookie, provider callback faults. */
    Configuration = "Configuration",
    /** A signed-in user tried a provider account that belongs to another user. */
    OAuthAccountNotLinked = "OAuthAccountNotLinked",
    /** Turnstile verification failed on a magic-link request. */
    CaptchaFailed = "CaptchaFailed",
    /** The fingerprint gate refused a magic-link request. */
    MsTokenFail = "MsTokenFail",
    /** A new qq.com address was asked to sign up through WeChat instead. */
    QqRequiresWechat = "QqRequiresWechat",
}
